module.exports = __webpack_public_path__ + "static/media/pebble.eb829cb4.svg";